export default class SmartProps {
    constructor(type) {
        this.required = false;
        this.default = undefined;
        this.sidebar = false;
        this.kind = 'generic';
        this.imageSetup = { width: 300, height: 200 };
        this.type = type;
    }
    withForm() {
        this.sidebar = true;
        return this;
    }
    withDefault(value) {
        this.default = value;
        return this;
    }
    withImageExampleSize(width, height) {
        this.imageSetup = { width, height };
        return this;
    }
    get isRequired() {
        this.required = true;
        return this;
    }
    static get string() {
        return new SmartProps('string');
    }
    static get number() {
        return new SmartProps('number');
    }
    static get array() {
        return new SmartProps('array');
    }
    static get bool() {
        return new SmartProps('boolean');
    }
    static get object() {
        return new SmartProps('object');
    }
    static get any() {
        console.error("Using any as a smartProp type is discouraged, please use object, string, bool ...");
        return new SmartProps('object');
    }
    static get image() {
        const prop = new SmartProps('object');
        prop.kind = 'image';
        return prop;
    }
    static get picto() {
        const prop = new SmartProps('object');
        prop.kind = 'picto';
        return prop;
    }
}

//# sourceMappingURL=smartProps.js.map
